import React from 'react';

import PropTypes from 'prop-types';

import A from 'wanderu-component-react-router-link';
import { localize } from 'wanderu-i18n';

import Toast from '../Toast/Toast';
import GDPRBannerEvents from './events/BannerEvents';

import styles from './GDPRBanner.scss';

function GDPRBanner(props) {
    const {
        t,
        onClose,
    } = props;

    return (
        <Toast
            data-id="gdprToast"
            onHide={onClose}
        >
            {t('gdprMessage', {
                cookiePolicy: (
                    <A
                        className={styles.cookiePolicy}
                        href="/cookie-policy/"
                        key="cookiePolicy"
                        target="_blank"
                    >
                        {t('cookiePolicy')}
                    </A>
                ),
            })}
        </Toast>
    );
}

GDPRBanner.propTypes = {
    onClose: PropTypes.func,
    t: PropTypes.func.isRequired,
};

GDPRBanner.defaultProps = {
    onClose() { },
};

export {
    GDPRBanner,
    GDPRBannerEvents,
};
export default localize(GDPRBanner, 'baseApp');
